import { render, staticRenderFns } from "./FeedbackDialog.vue?vue&type=template&id=89952132&scoped=true"
import script from "./FeedbackDialog.vue?vue&type=script&lang=js"
export * from "./FeedbackDialog.vue?vue&type=script&lang=js"
import style0 from "./FeedbackDialog.vue?vue&type=style&index=0&id=89952132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89952132",
  null
  
)

export default component.exports